import { render, staticRenderFns } from "./AdvertisementMediaForm.vue?vue&type=template&id=fc079dfe&scoped=true&"
import script from "./AdvertisementMediaForm.vue?vue&type=script&lang=js&"
export * from "./AdvertisementMediaForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementMediaForm.vue?vue&type=style&index=0&id=fc079dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc079dfe",
  null
  
)

export default component.exports